import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card"
import { Button } from "../components/ui/button"
import { Calendar } from "../components/ui/calendar"
import { Input } from "../components/ui/input"
import { Label } from "../components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table"
import { addDays, format } from 'date-fns'

const PRICES = {
  smallRegular: 5,
  smallRefrigerated: 7,
  smallHighSecurity: 10,
  mediumRegular: 8,
  mediumRefrigerated: 10,
  mediumHighSecurity: 15,
  largeRegular: 12,
  largeRefrigerated: 15,
  largeHighSecurity: 20,
};

const Reservations = () => {
  const [startDate, setStartDate] = useState<Date | undefined>(new Date());
  const [endDate, setEndDate] = useState<Date | undefined>(addDays(new Date(), 1));
  const [lockerType, setLockerType] = useState('');
  const [quantity, setQuantity] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);

  const calculatePrice = () => {
    if (!startDate || !endDate || !lockerType || !quantity) return;

    const days = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24)) + 1;
    const price = PRICES[lockerType as keyof typeof PRICES] * parseInt(quantity) * days;
    setTotalPrice(price);
  };

  const handleSave = () => {
    // Handle save logic here
    console.log('Saving reservation:', { startDate, endDate, lockerType, quantity, totalPrice });
  };

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Reservations</h1>
      
      <Card>
        <CardHeader>
          <CardTitle>New Reservation</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <Label>Start Date</Label>
                <Calendar
                  mode="single"
                  selected={startDate}
                  onSelect={setStartDate}
                  className="rounded-md border"
                />
              </div>
              <div>
                <Label>End Date</Label>
                <Calendar
                  mode="single"
                  selected={endDate}
                  onSelect={setEndDate}
                  className="rounded-md border"
                />
              </div>
            </div>
            <div className="space-y-4">
              <div>
                <Label htmlFor="lockerType">Locker Type</Label>
                <Select onValueChange={setLockerType}>
                  <SelectTrigger id="lockerType">
                    <SelectValue placeholder="Select locker type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="smallRegular">Small Regular</SelectItem>
                    <SelectItem value="smallRefrigerated">Small Refrigerated</SelectItem>
                    <SelectItem value="smallHighSecurity">Small High Security</SelectItem>
                    <SelectItem value="mediumRegular">Medium Regular</SelectItem>
                    <SelectItem value="mediumRefrigerated">Medium Refrigerated</SelectItem>
                    <SelectItem value="mediumHighSecurity">Medium High Security</SelectItem>
                    <SelectItem value="largeRegular">Large Regular</SelectItem>
                    <SelectItem value="largeRefrigerated">Large Refrigerated</SelectItem>
                    <SelectItem value="largeHighSecurity">Large High Security</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label htmlFor="quantity">Quantity</Label>
                <Input
                  id="quantity"
                  type="number"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </div>
              <Button onClick={calculatePrice}>Calculate Price</Button>
              <div className="mt-4 p-4 bg-gray-100 rounded-md">
                <p className="text-lg font-semibold">Total Price: ${totalPrice.toFixed(2)}</p>
              </div>
              <Button onClick={handleSave} className="w-full">Save Reservation</Button>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Upcoming Reservations</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Start Date</TableHead>
                <TableHead>End Date</TableHead>
                <TableHead>Locker Type</TableHead>
                <TableHead>Quantity</TableHead>
                <TableHead>Total Price</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>{format(new Date(), 'yyyy-MM-dd')}</TableCell>
                <TableCell>{format(addDays(new Date(), 3), 'yyyy-MM-dd')}</TableCell>
                <TableCell>Medium Regular</TableCell>
                <TableCell>2</TableCell>
                <TableCell>$48.00</TableCell>
                <TableCell>
                  <Button variant="outline" size="sm">Modify</Button>
                  <Button variant="destructive" size="sm" className="ml-2">Cancel</Button>
                </TableCell>
              </TableRow>
              {/* Add more rows as needed */}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default Reservations;